import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { IGraphChromatographicDataProps } from './types';

dayjs.extend(customParseFormat);
// faço a ordenação por data
export const sortByDate =
  (format: string, order: 'ASC' | 'DESC') =>
  (
    entryA: IGraphChromatographicDataProps,
    entryB: IGraphChromatographicDataProps,
  ) => {
    const dateA = dayjs(entryA.collectDate, format).toDate();
    const dateB = dayjs(entryB.collectDate, format).toDate();

    if (order === 'ASC') {
      return Number(dateA) - Number(dateB);
    }

    return Number(dateB) - Number(dateA);
  };
